import { Dropdown, FormController, FormLabel, IconButton, LoadingButton, MenuItem, TextField, Typography, } from '@one-thd/sui-atomic-components';
import { Close, ErrorFilled } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { StartExportLinkedAccountsHistory } from '../../hooks/linked-accounts';
import { useCommonContext } from '../../hooks/useContexts';
import { pushEventInfo } from '../../utils/analytics';
import { createTimeStamp } from '../../utils/date-utils';
import { DateRanges } from '../../utils/DateRanges';
import { getSvocId } from '../../utils/user';
import { DateSelectionDropdown } from '../shared/DateSelectionDropdown';
var exportFunction = function (dataType, fileName, DateRangeData, setShowWarning, setBtnLoading) {
    var startDate;
    var endDate;
    if (DateRangeData.startDate && DateRangeData.endDate) {
        startDate = DateRangeData.startDate;
        endDate = DateRangeData.endDate;
    }
    else {
        startDate = DateRanges[DateRangeData.dateSelectorValue].startDate;
        endDate = DateRanges[DateRangeData.dateSelectorValue].endDate;
    }
    var request = {
        familyPurchaseSearchRequest: {
            customerAccountIds: [getSvocId() || ''],
            searchType: dataType === 'summary' ? 'transaction' : 'details',
            sortBy: 'salesDate',
            sortOrder: 'DESC',
            allAccounts: true,
            fileName: fileName,
            jobType: 'purchaseHistory',
            startDate: startDate,
            endDate: endDate,
        },
        offlineProcessRequestType: 'LINKED_ACCOUNT_EXPORT',
        downloadType: 'CSV',
    };
    var setting = "download purchase history: ".concat(dataType);
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: { settings: setting },
    });
    StartExportLinkedAccountsHistory(request, setShowWarning, setBtnLoading);
};
var renderTitle = function (setRenderDownloadCongif) { return (React.createElement("div", { className: "sui-flex sui-justify-between", style: { borderBottom: 'black 1px solid' } },
    React.createElement(Typography, { variant: "h5" }, "Download Purchase History"),
    React.createElement(IconButton, { icon: Close, onClick: function () { return setRenderDownloadCongif(false); }, "aria-label": "Close", "data-testid": "close-button" }))); };
var renderWarning = function () { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "export-history__icon" },
        React.createElement(ErrorFilled, { color: "warning" })),
    React.createElement("div", { className: "export-history__warning" },
        React.createElement("p", { style: { paddingTop: 5, color: '#8f6e2e' } },
            "You have exceeded the allowed number of active downloads. Please wait until your active download is completed to retry another download.",
            React.createElement("a", { href: "/downloads" }, "Click here to view Downloads"))))); };
var renderInputs = function (props) {
    var dataType = props.dataType, fileName = props.fileName, setFileName = props.setFileName, setDataType = props.setDataType, dateSelectorValue = props.dateSelectorValue, setDateSelectorValue = props.setDateSelectorValue, showWarning = props.showWarning;
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-6" },
        React.createElement("div", { className: "sui-flex sui-gap-6" },
            React.createElement(FormController, { style: { zIndex: 2 } },
                React.createElement(FormLabel, { htmlFor: "drop-down-format" }, "Download Format"),
                React.createElement(Dropdown, { id: "drop-down-format", maxItems: 2, value: dataType, onChange: function (event) {
                        var eventValue = event.target.value;
                        setDataType(eventValue);
                    } },
                    React.createElement(MenuItem, { value: "summary" }, "Summary Data"),
                    React.createElement(MenuItem, { value: "details" }, "Detail Data"))),
            React.createElement("div", { style: { zIndex: 2 } },
                React.createElement(DateSelectionDropdown, { label: "Date", dateSelectorValue: dateSelectorValue, setDateSelectorValue: setDateSelectorValue, viewableMenuItems: dataType === 'details' ? 6 : undefined })),
            showWarning && renderWarning()),
        React.createElement(FormController, { fullWidth: true, style: { zIndex: 1 } },
            React.createElement(TextField, { id: "file-name-input", label: "Filename", defaultValue: fileName, onChange: function (event) {
                    return setFileName(event.target.value);
                } }))));
};
var renderAcceptBtn = function (dataType, fileName, dateRangeData, setShowWarning, btnLoading, setBtnLoading) {
    return (React.createElement("div", { className: "sui-flex sui-gap-1 sui-justify-end sui-items-end" },
        React.createElement("div", { className: "" },
            React.createElement(Typography, null, "Data will be exported as a csv file.")),
        React.createElement(LoadingButton, { loading: btnLoading, onClick: function () {
                setBtnLoading(true);
                exportFunction(dataType, fileName, dateRangeData, setShowWarning, setBtnLoading);
            }, "aria-label": "Initiate Download", "data-testid": "initiate-download-button" }, "Initiate Download")));
};
var ExportLinkedAccountsHistory = function (props) {
    var setRenderDownloadCongif = props.setRenderDownloadCongif;
    var _a = useState("Purchase_History_".concat(createTimeStamp())), fileName = _a[0], setFileName = _a[1];
    var _b = useState('last30Days'), dateSelectorValue = _b[0], setDateSelectorValue = _b[1];
    var _c = useState('summary'), dataType = _c[0], setDataType = _c[1];
    var _d = useState(false), showWarning = _d[0], setShowWarning = _d[1];
    var _e = useState(false), btnLoading = _e[0], setBtnLoading = _e[1];
    var commonContext = useCommonContext();
    var dateRangeData = {
        dateSelectorValue: dateSelectorValue,
        startDate: commonContext === null || commonContext === void 0 ? void 0 : commonContext.dateRangeOptions.startDate,
        endDate: commonContext === null || commonContext === void 0 ? void 0 : commonContext.dateRangeOptions.endDate,
    };
    var formData = {
        fileName: fileName,
        dataType: dataType,
        dateSelectorValue: dateSelectorValue,
        showWarning: showWarning,
        setFileName: setFileName,
        setDataType: setDataType,
        setDateSelectorValue: setDateSelectorValue,
    };
    return (React.createElement("div", { className: "sui-border sui-border-strong sui-border-solid sui-border-2", style: { padding: 10 }, "data-testid": "exportLinkedAccountsHistory" },
        React.createElement("div", { className: "export-history-form" },
            renderTitle(setRenderDownloadCongif),
            React.createElement("div", { className: "sui-grid sm:sui-grid-cols-1 md:sui-grid-cols-1 lg:sui-grid-cols-2 sui-gap-6" },
                renderInputs(formData),
                renderAcceptBtn(dataType, fileName, dateRangeData, setShowWarning, btnLoading, setBtnLoading)))));
};
export default ExportLinkedAccountsHistory;
